(() => {
  const hero=document.querySelector('.factory-hero'), template=document.querySelector('#factoryVideoTemplate');
  if(!hero || !template || hero.dataset.factoryReady) return;
  hero.dataset.factoryReady='true';
  const config=template.content.querySelector('video').dataset;
  const soundtrack=createSoundtrack();
  function createSoundtrack(){
    const button=hero.querySelector('#factorySound');
    let audio=null,enabled=false,finished=false,initialized=false;
    const update=()=>{
      button.textContent=enabled
        ?(finished?(button.dataset.finished||'Sound finished'):(button.dataset.on||'Sound on'))
        :(button.dataset.off||'Sound off');
      button.setAttribute('aria-pressed',String(enabled&&!finished));
    };
    function ensure(){
      if(audio)return;
      audio=document.createElement('audio');
      audio.hidden=true;audio.preload='none';audio.loop=false;
      audio.src=config.audio;audio.dataset.factorySoundtrack='once';
      hero.appendChild(audio);
      audio.addEventListener('ended',()=>{
        finished=true;audio.pause();update();
      });
    }
    async function sync(time=0){
      if(!enabled||finished)return;
      ensure();
      if(!initialized){
        // Synchronize once when sound is first enabled, never on a visual loop.
        audio.currentTime=Math.max(0,Math.min(time,22.1));
        initialized=true;
      }
      try{if(audio.paused)await audio.play();}
      catch(e){enabled=false;update();}
    }
    return {
      update,sync,
      get enabled(){return enabled;},
      pause(){audio?.pause();},
      async toggle(time,isPlaying,start){
        enabled=!enabled;
        if(enabled&&!finished){
          ensure();
          if(!isPlaying)start();
          await sync(time);
        }else audio?.pause();
        update();
      },
      reset(){
        audio?.pause();if(audio)audio.currentTime=0;
        initialized=false;finished=false;update();
      }
    };
  }
  const phone=matchMedia('(max-width:700px)').matches || /iPhone|iPad|Android/i.test(navigator.userAgent) || (navigator.maxTouchPoints>1 && /Macintosh/i.test(navigator.userAgent));
  if(phone){ mobileHero(); return; }
  const film=template.content.querySelector('video').cloneNode(true);
  hero.insertBefore(film,hero.querySelector('.optical-sparkles'));
  function mobileHero(){
    const cover=hero.querySelector('.factory-cover img');
    const play=hero.querySelector('#factoryPlay'),sound=hero.querySelector('#factorySound');
    const reduced=matchMedia('(prefers-reduced-motion:reduce)');
    const error=hero.querySelector('.factory-error');
    const events=new EventTarget(),INTRO=15.833333,LOOP=6.666342;
    let phase='intro',playing=false,started=0,elapsed=0,timer=0,generation=0,visibilityResume=false;
    const label=(button,key,fallback)=>button.dataset[key]||fallback;
    const clock=hero._factoryClock={
      get currentTime(){ const e=playing?(performance.now()-started)/1000:elapsed;return phase==='turn'?INTRO+e%LOOP:e; },
      get paused(){return !playing;},get ended(){return false;},
      videoWidth:360,videoHeight:640,
      getBoundingClientRect:()=>cover.getBoundingClientRect(),
      addEventListener:(...args)=>events.addEventListener(...args)
    };
    function notify(name){events.dispatchEvent(new Event(name));}
    function image(url,onload){
      cover.onload=onload||null;
      hero.querySelectorAll('.factory-cover source').forEach(s=>s.srcset=url);
      cover.src=url;
    }
    function controls(){
      play.textContent=playing?label(play,'pause','Pause film'):label(play,'play','Play film');
      soundtrack.update();
    }
    async function syncAudio(){
      if(playing)await soundtrack.sync(clock.currentTime);
    }
    function begin(next=phase){
      clearTimeout(timer);const token=++generation;
      phase=next;playing=false;elapsed=0;
      // Let the music flow continuously from assembly into the first spin.
      hero.classList.add('visual-fallback');
      error.hidden=true;
      image(config[next==='intro'?'introMobile':'turnMobile'],()=>{
        if(token!==generation)return;
        cover.onload=null;playing=true;started=performance.now();
        hero.classList.remove('is-loading','autoplay-blocked');
        hero.classList.toggle('finished',phase==='turn');
        controls();notify('play');syncAudio();
        if(phase==='intro')timer=setTimeout(()=>begin('turn'),INTRO*1000);
      });
      controls();
    }
    function pause(){
      ++generation;clearTimeout(timer);
      elapsed=playing?(performance.now()-started)/1000:elapsed;
      playing=false;soundtrack.pause();
      // Freeze the currently displayed frame; gracefully use a poster if CORS prevents readback.
      try{
        const c=document.createElement('canvas');c.width=cover.naturalWidth;c.height=cover.naturalHeight;
        c.getContext('2d').drawImage(cover,0,0);image(c.toDataURL('image/webp'));
      }catch(e){image(config.posterMobile);}
      controls();notify('pause');
    }
    play.onclick=()=>playing?pause():begin(phase);
    sound.onclick=()=>soundtrack.toggle(clock.currentTime,playing,()=>begin(phase));
    hero.querySelector('#factoryReplay').onclick=()=>{
      soundtrack.reset();begin('intro');
    };
    cover.onerror=()=>{cover.onerror=null;pause();error.hidden=false;image(config.posterMobile);};
    document.addEventListener('visibilitychange',()=>{
      if(document.hidden){visibilityResume=playing;if(playing)pause();}
      else if(visibilityResume){visibilityResume=false;begin(phase);}
    });
    reduced.addEventListener('change',e=>{if(e.matches){pause();hero.classList.add('finished');image(config.posterMobile);}});
    document.querySelector('#motionToggle')?.addEventListener('click',()=>{
      if(document.body.classList.contains('motion-paused')&&playing)pause();
    });
    hero.classList.add('visual-fallback');
    if(reduced.matches){hero.classList.remove('is-loading');hero.classList.add('finished');image(config.posterMobile);controls();}
    else begin('intro');
  }
  film.dataset.factoryReady='true';
  const play=document.querySelector('#factoryPlay'), sound=document.querySelector('#factorySound');
  const error=document.querySelector('.factory-error'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let mode='', allowPlay=!reduced.matches, suspended=false;
  const cover=hero.querySelector('.factory-cover img');
  let fallbackActive=false, fallbackPhase='intro', fallbackTimer=0;
  function setCover(url,onload){
    cover.onload=onload || null;
    hero.querySelectorAll('.factory-cover source').forEach(s=>s.srcset=url);
    cover.src=url;
  }
  function stopFallback(){
    clearTimeout(fallbackTimer);
    fallbackActive=false;
    cover.onload=null;
    hero.classList.remove('visual-fallback');
  }
  function animateFallback(phase='intro'){
    if(reduced.matches || !allowPlay) return;
    clearTimeout(fallbackTimer);
    fallbackActive=true;
    fallbackPhase=phase;
    hero.classList.add('visual-fallback');
    hero.classList.remove('autoplay-blocked');
    const key=(phase==='intro'?'intro':'turn')+(mode==='mobile'?'Mobile':'Desktop');
    setCover(film.dataset[key],()=>{
      cover.onload=null;
      hero.classList.remove('is-loading');
      hero.classList.toggle('finished',phase==='turn');
      if(phase==='intro') fallbackTimer=setTimeout(()=>animateFallback('turn'),15833);
    });
    update();
  }
  const label=(button,key,fallback)=>button.dataset[key] || fallback;
  film.defaultMuted=true;
  film.muted=true;
  film.playsInline=true;
  film.preload=reduced.matches?'none':'auto';
  hero.classList.add('is-loading','finished');
  function update(){
    if(fallbackActive){
      play.textContent=allowPlay?label(play,'pause','Pause film'):label(play,'play','Play film');
      return;
    }
    hero.classList.toggle('finished',hero.classList.contains('is-loading') || film.currentTime>=13.383333 || film.ended || (reduced.matches&&film.paused));
    play.textContent=(film.paused&&!allowPlay)||hero.classList.contains('autoplay-blocked')
      ?label(play,'play','Play film'):label(play,'pause','Pause film');
  }
  function chooseSource(){
    const next=matchMedia('(max-width:700px)').matches?'mobile':'desktop';
    if(next===mode) return;
    const wasPlaying=!film.paused, time=film.currentTime || 0;
    mode=next;
    film.poster=film.dataset[next==='mobile'?'posterMobile':'posterDesktop'];
    const wanted=film.dataset[next];
    const declared=[...film.querySelectorAll('source')].find(s=>!s.media || matchMedia(s.media).matches)?.src;
    if(!film.hasAttribute('src') && declared===new URL(wanted,location.href).href) return;
    if(reduced.matches && !allowPlay) return;
    film.addEventListener('loadedmetadata',()=>{
      if(time>0) film.currentTime=Math.min(time,film.duration || time);
      if(wasPlaying || allowPlay) start();
    },{once:true});
    film.src=wanted;
    film.load();
  }
  async function start(){
    allowPlay=true;
    error.hidden=true;
    chooseSource();
    // A reduced-motion visit has no selected native source until an explicit play.
    if(!film.currentSrc && ![...film.querySelectorAll('source')].some(s=>!s.media || matchMedia(s.media).matches)){
      film.src=film.dataset[mode];
      film.load();
    }
    try{
      await film.play();
      hero.classList.remove('autoplay-blocked');
    }catch(e){
      if(e.name==='NotAllowedError'){
        hero.classList.add('autoplay-blocked');
        animateFallback(fallbackPhase);
      }
      update();
    }
  }
  play.onclick=()=>{
    if(allowPlay&&!hero.classList.contains('autoplay-blocked')) {
      allowPlay=false;
      film.pause();
      soundtrack.pause();
      if(fallbackActive){
        clearTimeout(fallbackTimer);
        hero.classList.add('is-loading','finished');
        setCover(film.dataset[mode==='mobile'?'posterMobile':'posterDesktop']);
        update();
      }
    }
    else start();
  };
  // Keep native video sound muted; the separate, continuous score plays once.
  sound.onclick=()=>soundtrack.toggle(film.currentTime,!film.paused,start);
  document.querySelector('#factoryReplay').onclick=()=>{
    fallbackPhase='intro';
    soundtrack.reset();
    film.currentTime=0;
    hero.classList.remove('finished');
    start();
  };
  film.addEventListener('playing',()=>{
    stopFallback();
    hero.classList.remove('is-loading','autoplay-blocked');
    soundtrack.sync(film.currentTime);
    update();
  });
  for(const event of ['play','pause','timeupdate','ended']) film.addEventListener(event,update);
  film.addEventListener('pause',()=>{
    // A native end-of-video pause is only a visual loop boundary, not an audio pause.
    if(!film.ended)soundtrack.pause();
  });
  film.addEventListener('ended',()=>{
    if(allowPlay){film.currentTime=15.833333;start();}
  });
  film.addEventListener('error',()=>{
    error.hidden=false;
    hero.classList.add('is-loading','finished');
  });
  // Scrolling no longer pauses the film. Only leaving the tab suspends playback.
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden){suspended=allowPlay&&!film.paused;film.pause();soundtrack.pause();}
    else if(suspended&&allowPlay){suspended=false;start();}
  });
  reduced.addEventListener('change',e=>{
    if(e.matches){
      allowPlay=false;film.autoplay=false;film.pause();soundtrack.pause();stopFallback();
      setCover(film.dataset[mode==='mobile'?'posterMobile':'posterDesktop']);
      hero.classList.add('is-loading','finished');
    }
  });
  document.querySelector('#motionToggle')?.addEventListener('click',()=>{
    if(document.body.classList.contains('motion-paused')){allowPlay=false;film.pause();soundtrack.pause();}
  });
  // A phone may block even muted autoplay in power-saving mode; a real touch can unlock it.
  document.addEventListener('pointerdown',event=>{
    if(allowPlay && film.paused && hero.classList.contains('autoplay-blocked') && !event.target.closest('.factory-controls')) start();
  },{passive:true});
  if(reduced.matches){film.autoplay=false;film.removeAttribute('autoplay');film.pause();}
  chooseSource();
  if(allowPlay) start();
  addEventListener('resize',chooseSource,{passive:true});
  update();
})();
